import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import MailTemplates from './pages/mail/MailTemplates';

// --- AUTH & LAYOUT ---
import SignIn from './pages/auth/SignIn';
//import SignUp from './SignUp';
import Dashboard from './Dashboard';
import SessionExpiredPopup from './components/SessionExpiredPopup';

// --- PAGE COMPONENTS ---
import TopNews from './pages/press/TopNews';
import Stories from './pages/press/Stories';
import Featured from './pages/press/Featured';
import Awards from './pages/press/Awards';
import Press from './pages/press/Press';
import ManageUsers from './pages/auth/ManageUsers';
import TagManagement from './pages/tags/TagManagement';
import FlightScanUsers from './pages/flightscan/flsUsers';
import OdoMateUsers from './pages/odoMate/odoMateUsers';
import HomeTestRide from './pages/htr/offdays';
import HtrReservations from './pages/htr/reservations';
import HtrUpcomingBookings from './pages/htr/upcomingBookings';
import Wallpaper from './pages/wallpaper/wallpaperPage';
import UvMissionsPage from './pages/uv_missions/UvMissionsPage';
import NotificationsPage from './pages/notifications/NotificationsPage';

// --- DEALERSHIP PAGES ---
import DealershipMasterList from './pages/dealership/MasterList';
import DealershipMasterForm from './pages/dealership/MasterForm';

// --- SERVICE PAGES ---
import ServiceMasterList from './pages/service/MasterList';
import ServiceMasterForm from './pages/service/MasterForm';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [sessionData, setSessionData] = useState(null);

  const handleSignIn = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      setIsAuthenticated(true);
      try {
        const decodedToken = jwtDecode(accessToken);
        setSessionData({ name: decodedToken.name, email: decodedToken.email });
      } catch (error) {
        console.error("Invalid token during sign in", error);
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
  };

  /* const handleSignUp = () => {
     const accessToken = localStorage.getItem("accessToken");
     if (accessToken) {
       setIsAuthenticated(true);
       try {
         const decodedToken = jwtDecode(accessToken);
         setSessionData({ name: decodedToken.name, email: decodedToken.email });
       } catch (error) {
         console.error("Invalid token during sign up", error);
         setIsAuthenticated(false);
       }
     } else {
       setIsAuthenticated(false);
     }
   }; */

  const handleSignOut = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("accessToken");
    setSessionData(null);
  };

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          handleSignOut();
          window.dispatchEvent(new Event("auth:session-expired"));
        } else {
          setIsAuthenticated(true);
          setSessionData({ name: decodedToken.name, email: decodedToken.email });
        }
      } catch (error) {
        handleSignOut();
      }
    }
  }, []);

  return (
    <Router>
      <SessionExpiredPopup />
      <Routes>
        {/* Public Routes */}
        <Route path="/signin" element={!isAuthenticated ? <SignIn onSignIn={handleSignIn} /> : <Navigate to="/dashboard" />} />
        {/*<Route path="/signup" element={!isAuthenticated ? <SignUp onSignUp={handleSignUp} /> : <Navigate to="/dashboard" />} />*/}
        {/* PROTECTED ROUTES WRAPPED IN DASHBOARD */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Dashboard onSignOut={handleSignOut} sessionData={sessionData} />
            ) : (
              <Navigate to="/signin" replace />
            )
          }
        >

          {/* Press Pages */}
          <Route path="press-page/topnews" element={<TopNews />} />
          <Route path="press-page/stories" element={<Stories />} />
          <Route path="press-page/featured" element={<Featured />} />
          <Route path="press-page/awards" element={<Awards />} />
          <Route path="press-page/press" element={<Press />} />

          {/* Manage Users */}
          <Route path="manageusers/cmsusers" element={<ManageUsers />} />

          <Route path="dealer" element={<Navigate to="/dealer/dealership-master" replace />} />
          <Route path="service" element={<Navigate to="/service/service-centre-master" replace />} />
          <Route path="/press-page" element={<Navigate to="/press-page/topnews" replace />} />

          {/* Service Centre Master */}
          <Route path="service/service-centre-master" element={<ServiceMasterList />} />
          <Route path="service/service-centre-master/add" element={<ServiceMasterForm />} />
          <Route path="/service/service-centre-master/edit/:service_code/:country_code" element={<ServiceMasterForm />} />

          {/* Dealership Master */}
          <Route path="dealer/dealership-master" element={<DealershipMasterList />} />
          <Route path="dealer/dealership-master/add" element={<DealershipMasterForm />} />
          <Route path="/dealer/dealership-master/edit/:dealer_code/:country_code" element={<DealershipMasterForm />} />

          <Route path="mail-templates" element={<MailTemplates />} />

          {/*Tag Management Routes*/}
          <Route path="tag-management" element={<TagManagement />} />

          {/*Tag Management Routes*/}
          <Route path="manageusers/flightscanusers" element={<FlightScanUsers />} />
          <Route path="manageusers/odomateusers" element={<OdoMateUsers />} />

          {/*Home Test Ride Route*/}
          <Route path="home-test-ride/offdays" element={<HomeTestRide />} />
          <Route path="home-test-ride/reservation" element={<HtrReservations />} />
          <Route path="home-test-ride/upcoming-bookings" element={<HtrUpcomingBookings />} />

          {/* Wallpaper Route */}
          <Route path="wallpaper" element={<Wallpaper />} />

          {/* UV Missions Route */}
          <Route path="uv-missions" element={<UvMissionsPage />} />

          {/* Notifications Route */}
          <Route path="notifications" element={<NotificationsPage />} />

          {/* 404 Inside Dashboard */}
          <Route path="*" element={<div>404 - Page Not Found</div>} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
